//this file is necesary to create an instance of the history in the actions files.
import { createBrowserHistory } from 'history'

export default createBrowserHistory()